module.exports = __webpack_public_path__ + "img/72.5d4467d3.jpg";